import { Mail, Send } from 'lucide-react';
import { useState } from 'react';

import vector from '../assets/images/vector-login.png';
import logo from '../assets/svg/WebsiteLogo.svg';

const LoginPageV1 = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleGetOTP = () => {
    setIsLoading(true);

    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      alert(`OTP sent to ${email}`);
    }, 1500);
  };

  return (
    <div className='flex min-h-screen w-full items-center justify-center bg-white'>
      <div className='pointer-events-none absolute inset-0 overflow-hidden'>
        <div className='absolute bottom-1/3 left-1/4 h-56 w-56 rounded-full bg-purple-400 opacity-10'></div>
      </div>

      <div className='mx-auto flex max-h-[600px] max-w-[1440px] rounded-xl bg-white shadow-lg'>
        {/* Left Side - Vector Illustration */}
        <div className='hidden items-center justify-center bg-blue-50 p-12 lg:flex lg:w-1/2'>
          <div className='max-w-md'>
            <img
              src={vector}
              alt='Person working on laptop'
              className='h-auto w-full'
            />
          </div>
        </div>

        {/* Right Side - Login Form */}
        <div className='flex w-full items-center justify-center bg-white p-8 lg:w-1/2'>
          <div className='w-full max-w-md'>
            {/* Logo */}
            <div className='mb-8 flex justify-center'>
              <div className='flex h-20 w-20 transform items-center justify-center rounded-2xl'>
                <img src={logo} alt='logo' />
              </div>
            </div>

            {/* Welcome Text */}
            <div className='mb-8 text-center'>
              <h1 className='mb-2 text-3xl font-bold text-gray-900'>
                Fresher&apos;s Today
              </h1>
              <p className='text-gray-600'>
                Enter your email to receive a one-time password
              </p>
            </div>

            {/* Login Form */}
            <div className='space-y-6'>
              {/* Email Input */}
              <div>
                <label
                  htmlFor='email'
                  className='mb-2 block text-sm font-medium text-gray-700'
                >
                  Email Address
                </label>
                <div className='relative'>
                  <div className='pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3'>
                    <Mail className='h-5 w-5 text-gray-400' />
                  </div>
                  <input
                    type='email'
                    id='email'
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className='block w-full rounded-lg border border-gray-300 py-3 pl-10 pr-3 transition-all focus:border-transparent focus:outline-none focus:ring-2 focus:ring-blue-500'
                    placeholder='you@example.com'
                  />
                </div>
              </div>

              {/* Get OTP Button */}
              <button
                onClick={handleGetOTP}
                disabled={isLoading || !email}
                className='flex w-full items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-blue-500 to-blue-600 px-4 py-3 font-medium text-white transition-all hover:from-blue-600 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50'
              >
                {isLoading ? (
                  <>
                    <svg
                      className='h-5 w-5 animate-spin text-white'
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                    >
                      <circle
                        className='opacity-25'
                        cx='12'
                        cy='12'
                        r='10'
                        stroke='currentColor'
                        strokeWidth='4'
                      ></circle>
                      <path
                        className='opacity-75'
                        fill='currentColor'
                        d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
                      ></path>
                    </svg>
                    Sending OTP...
                  </>
                ) : (
                  <>
                    <Send className='h-5 w-5' />
                    Get OTP
                  </>
                )}
              </button>
            </div>

            {/* Footer Text */}
            {/* <div className='mt-8 text-center'>
            <p className='text-sm text-gray-600'>
              By continuing, you agree to our{' '}
              <a
                href='#'
                className='font-medium text-blue-600 hover:text-blue-700'
              >
                Terms of Service
              </a>{' '}
              and{' '}
              <a
                href='#'
                className='font-medium text-blue-600 hover:text-blue-700'
              >
                Privacy Policy
              </a>
            </p>
          </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPageV1;
